export enum ProductCombinationValueSlug {
  Bivolt = 'bivolt',
  NoColor = 'sem-cor',
  NoVoltage = 'sem-voltagem',
  Quadriband = 'quadriband',
  Voltage110 = '110-volts',
  Voltage220 = '220-volts',
}
